import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Redirect, Route, useHistory, useRouteMatch } from "react-router-dom";

import { LazyLoadComponent } from "widgets/lazyloader";
import { Spinner, SPINNER_SIZES } from "widgets/spinner";

import { Layout } from "../layout";
import { Interceptor } from "../../common/libs/services/interceptor";
import { AccountErrors } from "../../common/constants/account.constants";
import { useUserStore } from "@/common/libs/stores";

import styles from "./base.css";

Authendication.propTypes = {
  children: PropTypes.node
};
function Authendication({ children }) {
  let isAuthendicated = useUserStore((state) => state.isAuthendicated);
  let history = useHistory();
  let match = useRouteMatch("/");

  if (isAuthendicated === null) {
    return (
      <div className={styles.loaderBody}>
        <Spinner size={SPINNER_SIZES.MEDIUM} />
      </div>
    );
  } else if (isAuthendicated === false) {
    localStorage.setItem("redirectURL", history.location.pathname);
    history.push(`${match.url}login`);
    return "";
  } else if (isAuthendicated) {
    localStorage.setItem("isSessionExpired", false);
    let redirectURL = localStorage.getItem("redirectURL");
    if (redirectURL) {
      setTimeout(() => {
        history.push(redirectURL);
        localStorage.removeItem("redirectURL");
      }, 0);
    }
    return children;
  }
}

export function PublicRoute(props) {
  return <Route {...props} />;
}

export function PrivateRoute(props) {
  return <Route {...props} />;
}

export function PortalRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        let path = location.pathname;

        if (path.startsWith("/view/")) {
          path = path.replace("/view/", "/");

          return <Redirect to={path} />;
        }

        return children;
      }}
    />
  );
}

PortalRoute.propTypes = {
  children: PropTypes.node
};

export function AuthorizedComponents(props) {
  let history = useHistory();
  useEffect(function addingInterceptor() {
    //add interceptor
    Interceptor.addInterceptor({
      responseError: (error) => {
        return handleAccountErrorRedirections(error);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleAccountErrorRedirections(error) {
    if (
      error &&
      error.statusCode === 403 &&
      error.type === AccountErrors.TrialExpired
    ) {
      history.push("/trialexpired");
    } else if (error && error.type === AccountErrors.DunningExpired) {
      history.push("/dunning");
    }
    if (
      error?.statusCode === 401 &&
      error?.error_code === "KISSFLOW_ERROR_00014"
    ) {
      window.fb?.signout();
      window.location.reload();
    }
    return Promise.reject(error);
  }

  return (
    <Authendication>
      <Layout {...props} />
    </Authendication>
  );
}

// eslint-disable-next-line kf/const-naming-convention
export const routes = [
  {
    path: "/login",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/login")}
        componentName="Login"
        render={(Login) => <Login {...props} />}
      />
    )
  },
  {
    path: "/join",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/login")}
        componentName="SignUp"
        render={(SignUp) => <SignUp {...props} />}
      />
    )
  },
  {
    path: "/forgotpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/login")}
        componentName="ForgotPassword"
        render={(ForgotPassword) => <ForgotPassword {...props} />}
      />
    )
  },
  {
    path: "/resetpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/login")}
        componentName="ResetPassword"
        render={(ResetPassword) => <ResetPassword {...props} />}
      />
    )
  },
  {
    path: "/setpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/login")}
        componentName="SetPassword"
        render={(SetPassword) => <SetPassword {...props} />}
      />
    )
  },
  {
    path: "/trialexpired",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/trialexpired")
        }
        componentName="TrialExpired"
        render={(TrialExpired) => <TrialExpired {...props} />}
      />
    )
  },
  {
    path: "/dunning",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/dunning")}
        componentName="DunningExpired"
        render={(DunningExpired) => <DunningExpired {...props} />}
      />
    )
  }
];

export const PORTAL_ROUTES = [
  {
    path: "/login",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/portallogin")
        }
        componentName="Login"
        render={(Login) => <Login {...props} />}
      />
    )
  },
  {
    path: "/join",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/portallogin")
        }
        componentName="SignUp"
        render={(SignUp) => <SignUp {...props} />}
      />
    )
  },
  {
    path: "/forgotpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/portallogin")
        }
        componentName="ForgotPassword"
        render={(ForgotPassword) => <ForgotPassword {...props} />}
      />
    )
  },
  {
    path: "/resetpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/portallogin")
        }
        componentName="ResetPassword"
        render={(ResetPassword) => <ResetPassword {...props} />}
      />
    )
  },
  {
    path: "/setpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/portallogin")
        }
        componentName="SetPassword"
        render={(SetPassword) => <SetPassword {...props} />}
      />
    )
  },
  {
    path: "/trialexpired",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "account/trialexpired")
        }
        componentName="TrialExpired"
        render={(TrialExpired) => <TrialExpired {...props} />}
      />
    )
  },
  {
    path: "/dunning",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() => import(/* webpackPreload: true */ "account/dunning")}
        componentName="DunningExpired"
        render={(DunningExpired) => <DunningExpired {...props} />}
      />
    )
  }
];
